diy.angular.registerDirective('diyfminsert', ['$timeout', '$q', 'diyfmsectionsdata', 'diyfmconfig', 'diyfmselectiondata', 
                                              'diyl10n', 'diyfminsertprogress', 'diyfmmessages', 'diyfmstatus', 'diyfmuploadqueue',
function($timeout, $q, diyfmsectionsdata, diyfmconfig, diyfmselectiondata, diyl10n, diyfminsertprogress, 
        diyfmmessages, diyfmstatus, diyfmuploadqueue) {
    return {
        scope: true,
        template: '\
            <div class="fm-insert-hint" ng-hide="diyfmselectiondata.getInsertedItems().length">' + diyl10n('filemanager.insert.hint.message').format({plusIcon: '<span></span>'}) + '</div>\
            <div class="fm-insert-carousel-wrap" ng-show="diyfmselectiondata.getInsertedItems().length">\
                <div class="fm-insert-carousel"></div>\
            </div>\
            <div class="fm-insert-actions">\
                <button class="fm-main-button" ng-class="getInsertButtonClass()" ng-click="insert()" \
                    ng-bind-html="getInsertButtonText()"></button>\
                <div ng-show="diyfmselectiondata.getInsertedItems().length" ng-click="removeAll();" \
                    class="fm-clear-insertion"><small></small>' 
                    + diyl10n('filemanager.insert.clearselection') + '</div>\
            </div>\
        ',
        restrict: 'A',
        link: function(scope, elem, attr) {

            /* this is used in conjunction with the CSS antimations */
            var ANIMATION_DURATION = 300;
            var $carouselEl = jQuery(elem).find('.fm-insert-carousel');
            /* we have texts for both singluar and plural forms of the Add image(s) buttons */
            var insertSingularText = diyl10n('filemanager.insert.button.singulartext');
            var insertPluralText = diyl10n('filemanager.insert.button.pluraltext');
            var insertButtonText;
            
            var $dropArea = jQuery('.fm-insert-hint, .fm-insert-carousel-wrap');

            scope.diyfmselectiondata = diyfmselectiondata;

            /**
             * convert inserted items into items for the diy carousel
             * @param insertedItems
             * @returns {Array}
             */
            var getItems = function(insertedItems) {
                var items = [], item, source, imageStyle;
                for(var i = 0; i < insertedItems.length; i++) {
                    item = insertedItems[i];
                    source = item.getSource();
                    if (typeof source.getInsertThumbStyle === 'function') {
                        imageStyle = source.getInsertThumbStyle(item)
                    } else {
                        imageStyle = '';
                    }
                
                    items.push({
                        image: item.getThumb(),
                        item: item,
                        imageStyle: imageStyle
                    });
                }
                return items;
            };
            
            // XXX optimization
            // when large lists of images are added to carousel
            // it loads all images sequentially and a huge delay may be seen
            // while visible images are loaded, especially if we scroll to the
            // end of just added list
            // this is why we load images only for visible images
            // on items added and on carousel scroll
            var showImagesOnCarousel = function() {
                var visibleEls = $carouselEl.diy_carousel('getVisibleItemsEls');
                visibleEls.find('.fm-insert-thumb[data-style]').each(function(i, el){
                    var $el = jQuery(el);
                    $el.attr('style', $el.attr('data-style'))
                       .removeAttr('data-style');
                    
                });
            };

            /* initialize diy carousel */
            $carouselEl.diy_carousel({
                items: getItems(diyfmselectiondata.getInsertedItems()),
                itemTemplate: '<div class="fm-insert-thumb-container">\
                                   <div class="fm-insert-thumb" \
                                       data-style="background-image: url({image}); {imageStyle}">\
                                   </div>\
                                   <div class="fm-insert-remove-mask">\
                                       <span></span>\
                                   </div>\
                               </div>',
                selectable: false,
                afterScroll: function() {
                    showImagesOnCarousel();
                },
                afterItemsAdded: function() {
                    showImagesOnCarousel();
                }
            });

            var removeItemHandler = function(ev) {
                /* get the index of the item clicked */
                var idx = jQuery(this).index();
                /* get the item */
                var clickedItem = $carouselEl.diy_carousel('getItem', idx).item;

                scope.$apply(function() {
                    scope.diyfmselectiondata.removeItem(clickedItem, ['insert']);
                });
            };

            /*
            - Desktop
                - on hover the mask with the remove button is shown
                - on click the item is removed
            - Tablet (Touch)
                - on first tap, the mask with the remove button is shown
                - on second tap, the item is removed
             */
            if (!diy.editor.uiPreference.isPointerModeTouch()) {
                $carouselEl.delegate('.diy-carousel-item-wrapper', 'mouseover', function(ev) {
                    jQuery(this).find('.fm-insert-remove-mask').show();
                });
                $carouselEl.delegate('.diy-carousel-item-wrapper', 'mouseout', function(ev) {
                    jQuery(this).find('.fm-insert-remove-mask').hide();
                });
                $carouselEl.delegate('.diy-carousel-item-wrapper', 'click', removeItemHandler);
            } else {
                $carouselEl.delegate('.diy-carousel-item-wrapper', 'click', function(ev) {
                    if (!jQuery(this).find('.fm-insert-remove-mask').is(':visible')) {
                        jQuery('.diy-carousel-item-wrapper').find('.fm-insert-remove-mask').hide();
                        jQuery(this).find('.fm-insert-remove-mask').show();
                    } else {
                        removeItemHandler.call(this, ev);
                    }
                });
            }

            /* on any change within the inserted items array, update the items in the carousel */
            scope.$watchCollection('diyfmselectiondata.getInsertedItems()', function(newValue, oldValue) {
                if (!angular.equals(newValue, oldValue)) {
                    // Bugfix #DHDIYED-1038 - Ensure this code is executed after ng-show/ng-hide
                    // otherwise we render a component that is hidden, resulting in bad width/height
                    $timeout(function() {
                        /* get the different items that were added/inserted */
                        var diffItems;

                        /* if the item(s) were added */
                        if (newValue.length > oldValue.length) {
                            diffItems = newValue.filter(function(i) {return oldValue.indexOf(i) < 0;});
                            /* update the carousel and perform the animations */
                            var addedItemsEls = $carouselEl
                                .diy_carousel('addItems', getItems(diffItems), -1, true, function(addedItemsEls) {
                                    var imagesEls = addedItemsEls.find('.fm-insert-thumb-container');
                                    imagesEls.addClass('diy-carousel-item-animate-in');
                                    setTimeout(function() {
                                        imagesEls.removeClass('diy-carousel-item-animate-in').css('opacity', '');
                                    }, ANIMATION_DURATION);
                                });
                            addedItemsEls.find('.fm-insert-thumb-container').css('opacity', 0);
                        } else if (newValue.length < oldValue.length) { /* if the item(s) were removed */
                            diffItems = oldValue.filter(function(i) {return newValue.indexOf(i) < 0;});
                            /* get removed items */
                            var carouselDiffItems = getItems(diffItems);
                            /* get all carousel items */
                            var carouselAllItems = $carouselEl.diy_carousel('getItems');

                            /* get the indexes of the removed items */
                            var indexes = [];
                            carouselDiffItems.forEach(function(item) {
                                for (var i = 0; i < carouselAllItems.length; i++) {
                                    if (angular.equals(carouselAllItems[i], item)) {
                                        indexes.push(i);
                                    }
                                }
                            });

                            var itemsEls = jQuery(elem).find('.fm-insert-carousel .diy-carousel-item-wrapper');
                            indexes.forEach(function(index) {
                                itemsEls.eq(index).addClass('diy-carousel-item-animate-out');
                                setTimeout(function() {
                                    itemsEls.eq(index).css('opacity', 0);
                                }, ANIMATION_DURATION);
                            });
                            setTimeout(function() {
                                // if not all are deleted, use the delete one by one (slow)
                                if (newValue.length !== 0) {
                                    $carouselEl.diy_carousel('deleteItemsByIndexes', indexes);
                                } else {
                                    // if all are deleted, delete all (fast)
                                    $carouselEl.diy_carousel('option', 'items', []);
                                }
                            }, ANIMATION_DURATION);
                        } else {
                            /* if the items were changed but their number remained
                            the same, just update all the items. This is the case
                            when just 1 item is insertable, and we want to change it
                             */
                            $carouselEl
                                .diy_carousel('option', 'items', getItems(newValue));
                        }
                        var overLimit = getOverLimit();
                        if (overLimit > 0) {
                            var contentLimit = diyl10n("filemanager.insert.warning.limit").format({
                                maxLimit: diyfmconfig.getMaxSelection(),
                                alreadyExisting: diyfmconfig.getAlreadyExisting(),
                                overLimit: overLimit
                            });
                            showTooltip(contentLimit, 4500);
                        } else {
                            hideTooltip();
                        }
                    }.bind(this));
                }
            });

            var getOverLimit = function() {
                var insertedItemsLength = diyfmselectiondata.getInsertedItems().length;
                return insertedItemsLength + diyfmconfig.getAlreadyExisting() - diyfmconfig.getMaxSelection();
            }

            scope.getInsertButtonClass = function() {
                var obj = {};

                if (getOverLimit() > 0) {
                    obj['fm-insert-limit'] = true;
                } else if (diyfmselectiondata.getInsertedItems().length === 0) {
                    obj['fm-insert-none'] = true;
                }

                return obj;
            };

            scope.getInsertButtonText = function() {
                var insertedItemsLength = diyfmselectiondata.getInsertedItems().length;
                if (diyfmconfig.getMaxSelection() === 1) {
                    insertButtonText = insertSingularText;
                } else {
                    insertButtonText = insertPluralText;
                }
                return insertButtonText;
            };
            
            var hideTooltip = function() {
                jQuery(elem).find('button:diy-tooltip').diy_tooltip('hide');
            };

            var showTooltip = function(content, delay) {
                // create the tooltip that shows warning messages related to limitations upfront
                jQuery(elem).find('button').diy_tooltip({
                    triggerMode: 'none',
                    zIndex: diy.editor.getNewTopZIndex() // XXX hack - top zIndex should be computed inside the tooltip itself
                });
                jQuery(elem).find('button')
                    .diy_tooltip('option', 'content', content)
                    .diy_tooltip('option', 'show', function() {
                        jQuery(this).diy_tooltip('delayHide', delay);
                    })
                    .diy_tooltip('show');
            };

            /**
             * insert items
             * @returns {Array}
             */
            scope.insert = function() {

                // if items added are over the maximum limit or none at all
                var overLimit = getOverLimit();
                if (overLimit > 0) {
                    var contentLimit = diyl10n("filemanager.insert.warning.limit").format({
                        maxLimit: diyfmconfig.getMaxSelection(),
                        alreadyExisting: diyfmconfig.getAlreadyExisting(),
                        overLimit: overLimit
                    });
                    showTooltip(contentLimit, 4500);
                    return false;
                } else if (diyfmselectiondata.getInsertedItems().length === 0) {
                    var contentNone = diyl10n("filemanager.insert.warning.none");
                    showTooltip(contentNone, 1700);
                    return false;
                }

                // don't allow inserting while an upload is in progress
                if (diyfmstatus.getCurrentStatus().indexOf('upload') > -1) {
                    diyfmmessages.showMessage({
                        title: diyl10n('filemanager.close.upload.title'),
                        content: diyl10n('filemanager.close.insertupload.message'),
                        ok: diyl10n('filemanager.close.upload.wait')
                    });
                    return false;
                }

                var insertedItems = scope.diyfmselectiondata.getInsertedItems();

                diyfminsertprogress.show();
                scope.$emit('insertedItems', {
                    items: insertedItems
                });
                
                var 
                    queuePos = 0, 
                    itemsCount = insertedItems.length,
                    successItems = [],
                    errorItems = [],
                    errors = []
                ;
                
                function processQueue() {
                    if (queuePos === itemsCount) {
                        finishQueue();
                    } else {
                        var 
                            batch = [],
                            source = insertedItems[queuePos].getSource(),
                            sourceName = source.getName(),
                            batchSize = diyfmconfig.getSourceBatchSize(sourceName),
                            callback = diyfmconfig.getSourceCallback(sourceName);
                        ;
                        while (
                            queuePos < itemsCount
                            && insertedItems[queuePos].getSource().getName() == sourceName
                            && (batchSize === undefined || batch.length < batchSize)
                        ) {
                            batch.push(insertedItems[queuePos]);
                            queuePos++;
                        }
                        
                        diyfminsertprogress.showLoadingImage(batch[0].getThumb());

                        scope.$evalAsync(function(scope) {
                            diyfminsertprogress.setProgress(
                                queuePos, 
                                itemsCount
                            );
                        });

                        var runCallback = function(batch) {
                            callback(batch, function () {
                                // success
                                successItems = successItems.concat(batch);
                                processQueue();
                            }, function (error) {
                                // error
                                errorItems = errorItems.concat(batch);
                                errors.push(error);
                                processQueue();
                            });
                        }

                        if (typeof source.beforeInsert === 'function') {
                            source.beforeInsert(batch).then(function(batch){
                                runCallback(batch);
                            });
                        } else {
                            runCallback(batch);
                        }
                    }
                }
                function finishQueue() {
                    var finalCallback = diyfmconfig.getCallback();
                    
                    scope.$evalAsync(function(scope) {
                        diyfminsertprogress.hide();
                    });
                    
                    if (errorItems.length > 0) {
                        diyfmmessages.handleAddError({
                            errors: errors,
                            allFailed: (successItems.length === 0),
                            totalFilesFailed: errorItems.length
                        });
                        /* remove succesfully added items so that the user
                        can click again and try adding the remaining ones */
                        scope.$evalAsync(function(scope) {
                            successItems.forEach(function(item) {
                                diyfmselectiondata.removeItem(item, ['insert']);
                            });
                            var config = diyfmconfig.getConfig();
                            config.alreadyExisting += successItems.length;
                            diyfmconfig.setConfig(config);
                        });
                    } else {
                        scope.$evalAsync(function(scope) {
                            // TODO de-hardcode closing
                            diy.editor.filemanager.close();
                        });
                    }
                    
                    finalCallback({
                        errorItems: errorItems,
                        successItems: successItems
                    });
                }
                processQueue();
            };

            scope.removeAll = function() {
                scope.diyfmselectiondata.removeAllItems(['insert']);
                scope.$emit('clearAllInserted');
            };

            // support for drag and drop the the footer area
            $dropArea.bind('dragover', function(ev) {
                /* if there's no preventDefault in the dragover event,
                 then no drop will occur. highly undocumented featured,
                 found this out on StackOverflow */
                ev.preventDefault();
            });

            $dropArea.bind('dragover', function(ev) {
                jQuery(this).addClass('fm-insert-dragover');
            });

            $dropArea.bind('dragleave', function(ev) {
                jQuery(this).removeClass('fm-insert-dragover');
            });

            $dropArea.bind('drop', function(ev) {
                jQuery(this).removeClass('fm-insert-dragover');

                if (ev.originalEvent.dataTransfer
                    && ev.originalEvent.dataTransfer.files
                    && ev.originalEvent.dataTransfer.files.length > 0)
                {
                    scope.$emit('uploadFiles.up', ev.originalEvent.dataTransfer.files, undefined, true, 'drag-insert');
                } else {
                    scope.$apply(function(scope) {
                        var i = 0;
                        var selectedItems = diyfmselectiondata.getSelectedItems();
                        selectedItems.forEach(function(selectedItem) {
                            diyfmselectiondata.addItem(selectedItem, ['insert']);
                        });
                        
                        scope.$emit('addToInsertion', {
                            items: selectedItems,
                            source: 'dragdrop',
                            subsection: diyfmsectionsdata.getCurrentSubsection()
                        });
                        
                        diyfmselectiondata.removeAllItems(['select']);
                    });
                }

                return false;
            });
        }
    };
}]);



/*****************
 ** WEBPACK FOOTER
 ** ./source/cdn/document_root/s/diy/filemanager/directives/diyfminsert.js
 ** module id = 977
 ** module chunks = 0
 **/